import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["switch", "content"]

  connect() {
    this.updateVisibility()
  }

  toggle() {
    if (!this.switchTarget.checked) {
      this.contentTarget.querySelectorAll("input, textarea, select").forEach(input => {
        input.value = ""
      })
    }
    this.updateVisibility()
  }

  updateVisibility() {
    this.contentTarget.classList.toggle("hidden", !this.switchTarget.checked)
  }
}
